<app-loading *ngIf="contentReady"></app-loading>

<div class="container mb-4">
  <div class="row d-flex justify-content-center align-items-center" style="margin-bottom: 70px;">
    <div class="col-lg-5 col-md-7 col-sm-12">

      <form [formGroup]="formInfo" (ngSubmit)="onSubmit()">

        <!-- First Name -->
        <div class="form-group">
          <label class="label">{{ 'first Name' | transloco }}</label>
          <input class="input" type="text" formControlName="name" [ngClass]="{
              'is-invalid': formInfo.get('name')?.touched && formInfo.get('name')?.invalid,
              'is-valid': formInfo.get('name')?.touched && formInfo.get('name')?.valid
            }" />
        </div>

        <!-- Second Name -->
        <div class="form-group">
          <label class="label">{{ 'second Name' | transloco }}</label>
          <input class="input" type="text" formControlName="sname" />
        </div>

        <!-- Phone -->
        <div class="form-group">
          <label class="label">{{ 'phone' | transloco }}</label>
          <input class="input" type="text" formControlName="phone" />
        </div>

        <!-- Password -->
        <div class="form-group">
          <label class="label">{{ 'Password' | transloco }}</label>
          <input class="input" [type]="isPasswordVisible ? 'text' : 'password'" formControlName="password" />
        </div>

        <!-- Confirm Password -->
        <div class="form-group">
          <label class="label">{{ 'Confirm Password' | transloco }}</label>
          <input class="input" [type]="isPasswordVisible ? 'text' : 'password'" formControlName="c_Password" [ngClass]="{
              'is-invalid':
                formInfo.get('c_Password')?.touched &&
                formInfo.get('c_Password')?.invalid
            }" />

          <button type="button" class="hidePasswordBtn" (click)="togglePasswordVisibility()">
            {{ isPasswordVisible ? ('Hide Password' | transloco) : ('Show Password' | transloco) }}
          </button>
        </div>

        <hr class="line" />

        <button type="submit" class="submit-btn accont" [disabled]="formInfo.invalid">
          {{ isUpdatePage ? ('Edit' | transloco) : ('Create' | transloco) }}
        </button>

      </form>
    </div>
  </div>
</div>